import { Badge, Group } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useBadgeVariant } from "@hooks/useBadgeVariant";
import type { AudienceEntry, AudienceTargets } from "types/headsetReleaseTypes";
import { MODE_COLORS, targetName } from "./releaseFormat";

interface AudienceChipsProps {
  audience: AudienceEntry[];
  targets?: AudienceTargets;
  isLatest: boolean;
}

export function AudienceChips({ audience, targets, isLatest }: AudienceChipsProps) {
  const { t } = useTranslation();
  const badgeVariant = useBadgeVariant();
  if (!audience.length && !isLatest) {
    return (
      <Badge variant="outline" color="gray" tt="none">
        {t("headsetReleases.notAssigned")}
      </Badge>
    );
  }
  return (
    <Group gap={6}>
      {isLatest && (
        <Badge color="dark" variant={badgeVariant} tt="none">
          {t("headsetReleases.target.everyone")}
          {" · "}
          {t("headsetReleases.mode.available")}
        </Badge>
      )}
      {audience.map((entry) => {
        const name = targetName(entry.target, targets);
        return (
          <Badge key={entry.id} color={MODE_COLORS[entry.mode]} variant={badgeVariant} tt="none">
            {entry.target.kind === "org"
              ? name
              : t(`headsetReleases.targetInline.${entry.target.kind}`, { name })}
            {" · "}
            {t(`headsetReleases.mode.${entry.mode}`)}
          </Badge>
        );
      })}
    </Group>
  );
}
